module.exports = __webpack_public_path__ + "static/media/apr2025_crf.77d2ffaf.webp";